// <lema-tag variant="..."> — inline chip inside backend-rendered markdown. Unknown variants → "default".
import * as React from 'react'

import { type Tag, TagBadge } from '@/components/lemmala-design-system/tag/tag'

type TagVariant = NonNullable<Tag['variant']>

// `satisfies` fails the build if the DS renames one of these.
const LEMA_TAG_VARIANTS = ['default', 'success'] as const satisfies readonly TagVariant[]
type LemaTagVariant = (typeof LEMA_TAG_VARIANTS)[number]

const LEMA_TAG_BY_NAME: Record<string, LemaTagVariant> = Object.fromEntries(
  LEMA_TAG_VARIANTS.map((v) => [v, v]),
)

const parseLemaTagVariant = (variant?: string): LemaTagVariant =>
  (variant && LEMA_TAG_BY_NAME[variant]) || 'default'

const LemaTagSuccessDot = (
  <span className='size-1.5 shrink-0 rounded-full bg-main-foreground-success' />
)

export const LemaTag = ({
  variant,
  children,
}: React.HTMLAttributes<HTMLSpanElement> & { variant?: string }) => {
  const resolvedVariant = parseLemaTagVariant(variant)
  const name = typeof children === 'string' ? children : String(children ?? '')
  // Inline inside backend-rendered cells — margins (not gap) space chips across wraps.
  return (
    <TagBadge
      tag={{
        id: `lema-tag-${name}`,
        name,
        variant: resolvedVariant,
        icon: resolvedVariant === 'success' ? LemaTagSuccessDot : undefined,
      }}
      rootClassName='align-middle mr-1 mb-1'
    />
  )
}
